<template>
    <div>
        <h3 class="my-15">Titre et accroche</h3>

        <div class="flex flex-col space-y-5">
            <p class="uppercase text-indigo-600 text-base font-normal">Titre de mon CV</p>
            <p class="text-base font-light">Le titre, reflète votre objectif professionnel ou poste visé (maximum 50 caractères).</p>
            <input-text
                name="title"
                :value="((form || {}).name || '')"
                placeholder="Titre de mon CV"
                :error="true"
                :maxlength="50"
                @input="(newValue) => {(form || {}).name = newValue; (errors || []).name = []}"
                @loseFocus="saveDatas()"
                :msg-error="((errors || []).name || [])[0]"
            />
        </div>
        <div class="mt-10 flex flex-col space-y-5">
            <p class="uppercase text-indigo-600 text-base font-normal">Accroche</p>
            <p class="text-base font-light">
                L’accroche a pour but d’attirer l’attention du recruteur et de vous démarquer des  autres candidats. Enquelques mots, elle doit faire comprendre au recruteur le métier recherché et lui donner envie de vous renvontrer.
            </p>
            <input-text-area
                name="accroche"
                :value="((form || {}).description || '')"
                placeholder="Accroche"
                :error="true"
                :maxlength="form.type === constants.CV_TYPES.DASHBOARD ? 250 : 400"
                :size="5"
                @input="(newValue) => {(form || {}).description = newValue;}"
                @loseFocus="saveDatas()"
                :msg-error="((errors || []).description || [])[0]"
            />
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import InputText from './../../../components/Inputs/InputText.vue';
import InputTextArea from './../../../components/Inputs/InputTextArea.vue';
import Constants from './../../../constants';

export default {
  name:'TitreEtAccroche',

  components:{
    InputText,
    InputTextArea
  },

  data(){
    return {
      constants: Constants,
    };
  },

  methods:{
    ...mapMutations({
      SET_FORM: 'curriculumVitae/SET_FORM'
    }),
    ...mapActions({
      saveDatas: 'curriculumVitae/saveDatas',
    }),
  },

  computed:{
    ...mapGetters({
      form: 'curriculumVitae/form',
      errors: 'curriculumVitae/errors'
    })
  }
};
</script>
